import { useEffect, useState } from "react"
import { FaEllipsis, FaPlus } from "react-icons/fa6"
import { TiTick } from "react-icons/ti"
import { useLocation, useNavigate } from "react-router-dom"
import axios from "axios"
import api from "../config/backend"
import { SpinnerCircular } from "spinners-react"
import { toast } from "react-toastify"

// Calculate total amount of a invoice
const calcualteTotal = (invoice) => {
    let total = 0

    const items = invoice.items

    items.forEach(item => {
        total += (item.quantity * item.rate)
    })

    const subtotal = total

    if (invoice.discount) {
        if (invoice.discount.ispercentage) {
            total = total - (total * invoice.discount.value / 100)
        } else {
            total = total - invoice.discount.value
        }
    }

    if (invoice.adjustment) {
        total = total + invoice.adjustment.value
    }

    let tax = 0

    if (invoice.taxdetails) {
        tax = total * invoice.taxdetails.rate / 100
    }

    total = total + tax

    return { total, subtotal }
}

const InvoicesList = ({ invoicesList, setCreateInvoice }) => {
    const [activeInvoice, setActiveInvoice] = useState(0)
    const [invoicePreview, setInvoicePreview] = useState("")
    const [previewLoading, setPreviewLoading] = useState(false)

    const navigate = useNavigate()

    const token = localStorage.getItem("_crm__token")

    const searchparams = useLocation().search

    const hash = new URLSearchParams(searchparams).get("hash")

    const generatePreview = async (download) => {
        setPreviewLoading(download ? "download" : "preview")

        const { data, status } = await axios.post(`${api}/Accounting/invoice-pdf`,
            {
                token,
                hash: hash ? hash : invoicesList[activeInvoice].hash,
                download
            },
            {
                responseType: download ? "blob" : undefined
            }
        )

        setPreviewLoading(false)

        if (download) {
            const link = document.createElement("a")
            link.href = window.URL.createObjectURL(new Blob([data]))
            link.setAttribute("download", `Invoice-${String(invoicesList[activeInvoice].invoiceindex).padStart(6, "0")}.pdf`)
            document.body.appendChild(link)
            link.click()
            return
        }

        if (data.success) {
            setInvoicePreview(data.preview)
        }
    }

    const handleShare = async () => {
        setPreviewLoading("share")
        const { data, status } = await axios.post(`${api}/Accounting/invoice-share`, { token, hash: invoicesList[activeInvoice].hash })

        setPreviewLoading(false)

        if (data.success) {
            navigator.clipboard.writeText(data.link)
            toast.info("Link copied to clipboard")
        }
    }

    useEffect(() => {
        generatePreview()
    }, [activeInvoice])

    // Auto select the quote that matches hash
    useEffect(() => {
        const getIndex = (value, arr, prop) => arr.findIndex(obj => obj[prop] === value)

        if (hash) {
            const invoicePosition = getIndex(hash, invoicesList,"hash")

            setActiveInvoice(invoicePosition)
        }
    }, [hash])

    return (
        <div className="_7fzc">
            <div className="sidebar app-new-quotes-sidebar">
                <div className="header">
                    <div>All Invoices</div>
                    <div className="hatchet-scab">
                        <button onClick={() => setCreateInvoice(true)}><FaPlus /> New</button>
                    </div>
                </div>
                <div className="reacting-eggs">
                    {invoicesList.map((invoice, index) => {
                        const { total, subtotal } = calcualteTotal(invoice)

                        return (
                            <div
                                key={index}
                                className={activeInvoice === index ? "stubby-hex active" : "stubby-hex"}
                                onClick={() => {
                                    setActiveInvoice(index)
                                    navigate("/accounting/invoices")
                                }}
                            >
                                <div className="spinner-them">
                                    <div className="customer-name">{invoice.customer.firstname} {invoice.customer.lastname}</div>
                                    <div>{invoice.customer.currency.icon}{total}</div>
                                </div>
                                <div className="spinner-them">
                                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                        <div>INV-{String(invoice.invoiceindex).padStart(6, "0")}</div>
                                        {invoice.sent === false && <span style={{ color: "white", backgroundColor: "rgb(136, 178, 225)", fontSize: "8px", padding: "1px 3px", height: "16px", display: "flex", alignItems: "center" }}>DRAFT</span>}
                                    </div>
                                    <div>{new Date(invoice.invoicedate).toDateString()}</div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="squiffed-dint app-new-invoice-squiffed-dint">
                {/* <div className="header">
                    INV-{String(invoicesList[activeInvoice].invoiceindex).padStart(6, "0")}
                </div> */}
                <div className="settings">
                    <div onClick={() => navigate("/accounting/invoices/edit/" + invoicesList[activeInvoice].hash)}>Edit</div>
                    <div onClick={() => navigate("/accounting/invoices/create/" + invoicesList[activeInvoice].hash)}>Send e-mail</div>
                    <div className={previewLoading === "share" ? "loading" : undefined} onClick={() => handleShare()}>Share</div>
                    <div className={previewLoading === "download" ? "loading" : undefined} onClick={() => generatePreview(true)}>Download PDF</div>
                </div>
                <div className="paid-icon">
                    <TiTick style={{fontSize:'40px'}} color="white"/> <div>Confirm Payment</div>
                </div>
                <div className="drape-cop">
                    {previewLoading === "preview" ? (
                        <div className="woodmen-that">
                            <SpinnerCircular size="70" color="#3b70ad" />
                        </div>
                    ) : (
                        <div className="preview" dangerouslySetInnerHTML={{
                            __html: invoicePreview
                        }}>

                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default InvoicesList
